import { styled } from "sharedUI/styles";
import { BaseScreenStyle } from "../../../ui/views/base-screen/base-screen-style";
import { overlayYScrollbar } from "sharedUI/style";

export const OverviewScreenStyle = styled(BaseScreenStyle)`
    display: flex;
    flex-direction: column;

    .ovsc-tile-region {
        display: grid;
        grid-gap: 16px;
        grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    }

    .ovsc-header-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .button-link {
        display: flex;
        color: ${p => p.theme.textPale};
        font-size: 13px;
        align-items: center;
        cursor: pointer;
        padding: 4px 12px;
        border-radius: 8px;
        margin-left: 4px;
        transition: background-color ${p => p.theme.transitionBase};

        > .title {
            margin-left: 4px;
        }

        :hover {
            background-color: ${p => p.theme.bgColorMediumTransparent};
        }
    }

    .ovsc-vid-content {
        position: absolute;
        width: 100%;
        height: 100%;

        background-color: ${p => p.theme.bgGreen};
        color: white;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .invite-member-button {
        white-space: nowrap;
        margin: 0 10px;
    }

    > * {
        flex-shrink: 0;
    }

    .header-right {
        display: flex;
    }
`;

const TileContent = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PlusContent = styled(TileContent)`
    color: ${p => p.theme.acceptColor};
`;

export const VideoBackground = styled(TileContent)<{ backgroundUrl: string }>`
    background-image: url("${p => p.backgroundUrl}");
    background-size: cover;
    filter: brightness(0.95);
`;

export const NewAppModalStyle = styled.div`
    display: flex;
    flex-direction: column;
    width: 384px;
    padding-top: 8px;

    .field {
        margin-bottom: 24px;
    }

    .field-label {
        margin-bottom: 8px;

        & > * {
            margin: 0;
        }
    }

    small {
        display: block;
        margin-top: 8px;
        color: ${p => p.theme.textXpale};
        font-size: 12px;
    }

    .label {
        display: inline-block;
        color: ${p => p.theme.textBase};
        font-weight: 600;
        font-size: 13px;
    }

    .title-h2,
    .title-h3 {
        color: ${p => p.theme.textDark};
        font-size: 19px;
        font-weight: 800;
    }

    .title-h3 {
        font-size: 15px;
    }

    .subtitle {
        color: ${p => p.theme.textPale};
        font-size: 13px;
        line-height: 1.33;
    }

    .title-h2 + .subtitle {
        margin-top: 4px;
    }

    .data-sources + .field {
        margin: 16px 0 0 0;
    }
`;

export const Panels = styled.ul`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 12px;
    user-select: none;

    &.grid-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .panel-button {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 24px 20px;
        border-radius: 12px;
        cursor: pointer;
        border: solid 2px ${p => p.theme.borderBase};
        transition: all ${p => p.theme.transitionBase};

        &.centered {
            align-items: center;
        }

        &.tight {
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 16px 20px;

            .source-image {
                margin: 0;
            }

            & > * + * {
                margin-left: 12px;
            }
        }

        &:hover,
        &:focus {
            color: ${p => p.theme.iconDark};
            border: solid 2px ${p => p.theme.n500}AA;

            .label {
                color: ${p => p.theme.textBase};
            }
        }

        &.selected {
            border-color: ${p => p.theme.accentPrimary};
            color: ${p => p.theme.iconDark};

            svg {
                color: ${p => p.theme.accentPrimary};
            }

            .label {
                color: ${p => p.theme.textBase};
                font-weight: 500;
            }
        }

        svg {
            color: ${p => p.theme.iconBase};
        }

        .label {
            margin-top: 8px;
            color: ${p => p.theme.textPale};
            font-size: 12px;
            font-weight: normal;
            transition: all ${p => p.theme.transitionBase};
        }

        .source-image {
            width: 40px;
            height: 40px;
            margin-bottom: 12px;
        }
    }
`;

export const SelectSourceModalStyle = styled(NewAppModalStyle)`
    padding-top: 0;
    width: 560px;
    max-height: 400px;
    ${overlayYScrollbar}

    .container {
        display: flex;
        flex-direction: column;
        margin: 0 32px;
        padding-bottom: 30px;
    }
`;

export const DataSourcesStyle = styled(Panels)`
    grid-template-columns: 1fr 1fr;
    margin-top: 16px;
`;
